
export default {
  props: ['error']
}
